// import axios from "axios";
// import { useEffect, useState, useRef } from "react";

// // Swiper imports
// import { Swiper, SwiperSlide } from "swiper/react";
// import {
//   Navigation,
//   Pagination,
//   Autoplay,
//   EffectFade,
// } from "swiper/modules";

// // Swiper styles
// import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/pagination";
// // Import new effect-fade
// import "swiper/css/effect-fade";
// import { useLanguage } from "../LanguageContext";

// function Banner() {
//   const API_URL = process.env.REACT_APP_API_URL;
//   const IMG_BASE_URL = process.env.REACT_APP_API_BASE_URL_img;
//   const { lang } = useLanguage();

//   const [bannerData, setBannerData] = useState([]);

//   const getBanner = async () => {
//     try {
//       const response = await axios.get(`${API_URL}/BannerRoutes/get/web`);
//       // const activeData = (response.data?.data || []).filter(
//       //   (item) => item.isActive === true,
//       // );
      
//     const today = new Date();
//     today.setHours(0, 0, 0, 0);

//     const activeData = (response.data?.data || []).filter((item) => {
//       // Active check
//       if (!item.isActive) return false;

//       // Publish Date check
//       if (item.publishDate) {
//         const publishDate = new Date(item.publishDate);
//         publishDate.setHours(0, 0, 0, 0);

//         // Agar publish date future hai to hide karo
//         if (today < publishDate) return false;
//       }

//       // Expiry Date check
//       if (item.expiryDate) {
//         const expiryDate = new Date(item.expiryDate);
//         expiryDate.setHours(23, 59, 59, 999);

//         // Agar expire ho gaya hai to hide karo
//         if (today > expiryDate) return false;
//       }

//       return true;
//     });

//       setBannerData(activeData);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };



//   useEffect(() => {
//     getBanner();
//   }, []);

//   return (
//     <section className="hero-slider hero-style">
// <Swiper
//   modules={[Navigation, Pagination, Autoplay, EffectFade]}
//   effect="fade"
//   fadeEffect={{
//     crossFade: true,
//   }}
//   loop={bannerData.length > 1}
//   observer={true}
//   observeParents={true}
//   watchOverflow={true}
//   navigation={{
//     nextEl: ".custom-next",
//     prevEl: ".custom-prev",
//   }}
//   pagination={{
//     clickable: true,
//   }}
//   autoplay={{
//     delay: 3000,
//     disableOnInteraction: false,
//     pauseOnMouseEnter: true,
//   }}
// >
//         {bannerData?.map((item, index) => (
//           <SwiperSlide key={item?.id || index}>
//             <div
//               className="slide-inner"
//               // style={{
//               //   backgroundImage: `url(${IMG_BASE_URL}/${item?.bannerImage})`,
//               // }}
//             >
//                <img
//       src={`${IMG_BASE_URL}/${item?.bannerImage}`}
//       alt={item?.title?.[lang]}
//       className="banner-image"
//     />
//               <div className="container">
//                 <div className="slider-content">
//                   <div className="slide-title">
//                     <h1 className="banner-slider-title fw-600 text-white">
//                       {item?.title?.[lang]}
//                     </h1>
//                   </div>

//                   <div className="slide-text">
//                     <p className="banner-slider-text text-white fs-18">
//                       {item?.subTitle?.[lang]}
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </SwiperSlide>
//         ))}
//       </Swiper>

//       <div className="custom-prev">
//         <i className="fa-solid fa-chevron-left"></i>
//       </div>

//       <div className="custom-next">
//         <i className="fa-solid fa-chevron-right"></i>
//       </div>
//     </section>
//   );
// }

// export default Banner;

import axios from "axios";
import { useEffect, useState, useRef } from "react";

// Swiper imports
import { Swiper, SwiperSlide } from "swiper/react";
import {
  Navigation,
  Pagination,
  Autoplay,
} from "swiper/modules";

// Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useLanguage } from "../LanguageContext";

function Banner() {
  const API_URL = process.env.REACT_APP_API_URL;
  const IMG_BASE_URL = process.env.REACT_APP_API_BASE_URL_img;
  const { lang } = useLanguage();

  const [bannerData, setBannerData] = useState([]);

  const getBanner = async () => {
    try {
      const response = await axios.get(`${API_URL}/BannerRoutes/get/web`);
      // const activeData = (response.data?.data || []).filter(
      //   (item) => item.isActive === true,
      // );
      
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const activeData = (response.data?.data || []).filter((item) => {
      // Active check
      if (!item.isActive) return false;

      // Publish Date check
      if (item.publishDate) {
        const publishDate = new Date(item.publishDate);
        publishDate.setHours(0, 0, 0, 0);

        // Agar publish date future hai to hide karo
        if (today < publishDate) return false;
      }

      // Expiry Date check
      if (item.expiryDate) {
        const expiryDate = new Date(item.expiryDate);
        expiryDate.setHours(23, 59, 59, 999);

        // Agar expire ho gaya hai to hide karo
        if (today > expiryDate) return false;
      }

      return true;
    });

      setBannerData(activeData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };



  useEffect(() => {
    getBanner();
  }, []);

  return (
    <section className="hero-slider hero-style">
<Swiper
  modules={[Navigation, Pagination, Autoplay]}
  loop={bannerData.length > 1}
  observer={true}
  observeParents={true}
  watchOverflow={true}
  navigation={{
    nextEl: ".custom-next",
    prevEl: ".custom-prev",
  }}
  pagination={{
    clickable: true,
  }}
  autoplay={{
    delay: 3000,
    disableOnInteraction: false,
    pauseOnMouseEnter: true,
  }}
>
        {bannerData?.map((item, index) => (
          <SwiperSlide key={item?.id || index}>
            <div
              className="slide-inner"
              // style={{
              //   backgroundImage: `url(${IMG_BASE_URL}/${item?.bannerImage})`,
              // }}
            >
               <img
      src={`${IMG_BASE_URL}/${item?.bannerImage}`}
      alt={item?.title?.[lang]}
      className="banner-image"
    />
              <div className="container">
                <div className="slider-content">
                  <div className="slide-title">
                    <h1 className="banner-slider-title fw-600 text-white">
                      {item?.title?.[lang]}
                    </h1>
                  </div>

                  <div className="slide-text">
                    <p
                      className={`banner-slider-text text-white fs-18 ${
                        item?.subTitle?.[lang]?.trim() ? "has-text" : "no-text"
                      }`}
                    >
                      {item?.subTitle?.[lang]}
                    </p>
                    {/* <p className="banner-slider-text text-white fs-18">
                      {item?.subTitle?.[lang]}
                    </p> */}
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="custom-prev">
        <i className="fa-solid fa-chevron-left"></i>
      </div>

      <div className="custom-next">
        <i className="fa-solid fa-chevron-right"></i>
      </div>
    </section>
  );
}

export default Banner;
